// ** MUI Imports
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import Typography from '@mui/material/Typography'

import { DeleteForeverOutlined, Poll } from '@mui/icons-material'
import { Alert, Box, Grid, IconButton, Snackbar, Stack } from '@mui/material'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Api from '../api/Api'
import ConfirmDialog from './ConfirmDialog'
import ThumbImage from './ThumbImage'

const PollCard = ({ poll, onRemove, remove }) => {
  const navigate = useNavigate();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)
  const [alertState, setAlertState] = useState({ show: false, success: true, message: '' })

  const removePoll = async () => {
    setShowConfirmDialog(false)
    try {
      await Api.deletePoll(poll._id, poll.tangledIdemGUID);
      setAlertState({ show: true, success: true, message: `The poll "${poll.question}" was removed.` })
      onRemove && onRemove();
    } catch (e) {
      setAlertState({ show: true, success: false, message: `Could not delete the poll "${poll.question}".` })
    }
  }

  const handleCloseFormUpdateAlert = (/** @type {any} */ _event, /** @type {string} */ reason) => {
    if (reason === 'clickaway') {
      return
    }

    setAlertState({ show: false, success: true, message: '' })
  }

  return (
    <Card>
      <Grid
        container
        sx={({ breakpoints }) => ({
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 4,
          [breakpoints.down('md')]: { p: 2 }
        })}
      >
        <Stack direction={'row'} spacing={2} flexGrow={1}>
          <ThumbImage poll={poll} onClick={() => navigate(`/poll/${poll._id}`)} />
          <Box sx={{ mb: 1, display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
            <Stack direction={'row'} justifyContent={'space-between'}>
              <Typography variant='h6' sx={{ fontWeight: 100 }}>
                {poll.question}
              </Typography>
              {remove && <IconButton onClick={() => setShowConfirmDialog(true)} sx={{ width: '1.5em', height: '1.5em' }}>
                <DeleteForeverOutlined />
              </IconButton>}
            </Stack>
            <Box flexGrow={1} alignItems={'end'} display={'flex'} mt={1}>
              <Button variant='outlined' endIcon={<Poll />} onClick={() => navigate(`/poll/${poll._id}`)}>Manage</Button>
            </Box>
          </Box>
        </Stack>
      </Grid>
      {alertState.show && (
        <Snackbar
          open={alertState.show}
          autoHideDuration={4000}
          onClose={handleCloseFormUpdateAlert}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert
            onClose={handleCloseFormUpdateAlert}
            severity={alertState.success ? 'success' : 'error'}
            variant={'filled'}
            elevation={6}
            sx={{ width: '100%' }}
          >
            {alertState.message}
          </Alert>
        </Snackbar>
      )}
      {showConfirmDialog && (
        <ConfirmDialog
          open={showConfirmDialog}
          dialogTitle={'Remove Poll'}
          contentText={`Do you want to remove the poll "${poll.question}"?`}
          confirmText={'Remove'}
          cancelText={'Cancel'}
          onCancel={() => setShowConfirmDialog(false)}
          confirmStartIcon={<DeleteForeverOutlined />}
          onConfirm={removePoll}
        ></ConfirmDialog>
      )}
    </Card>
  )
}

PollCard.propTypes = {
  poll: PropTypes.any.isRequired,
  onRemove: PropTypes.func,
  remove: PropTypes.bool,
}

export default PollCard;
